import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITY_APPS_RESOURCE, CREATE_COMMUNITY_APP_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateCommunityAppService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_COMMUNITY_APP_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.communityApps(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: COMMUNITY_APPS_RESOURCE,
            valuesModifier: values => ({ ...values, app: { ...values.appDetails } }),
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createCommunityAppFailed'),
            onSuccessMessage: t('createCommunityAppSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateCommunityAppService;
